import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import dayjs from 'dayjs';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchDateMonth, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchDateMobile } from './component/search/search';
import { formatDateTime, changeNum } from './common/function';

import useWindowSize from './hook/useWindowSize'

function Settlement() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([0, 0])

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([])
    const [reload, setReload] = useState(false)
    const [modal, setModal] = useState(false)

    useEffect(() => {
        dispatch(change_Current_Location("정산내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "정산내역",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChangeMaxPage = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷
    const inputRef = useRef(null);   // 숨겨진(또는 실제) datepicker input
    const pickerRef = useRef(null);  // Litepicker instance

    // 날짜 상태 (초기값: 이번 달)
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // ★ 핵심: inputRef.current(또는 화면폭) 바뀔 때마다 재부착
    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;

        // 기존 인스턴스 정리
        if (pickerRef.current) {
            pickerRef.current.destroy();
            pickerRef.current = null;
        }

        // 새 인스턴스 부착
        const picker = new Litepicker({
            element: el,
            lang: "ko",
            singleMode: false,
            format: "YYYY/MM/DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: { minYear: 2020, maxYear: 2030, months: true, years: true },
            setup: (p) => {
                p.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY/MM/DD"));
                    setNextDate(end.format("YYYY/MM/DD"));
                });
            },
        });

        pickerRef.current = picker;

        // 현재 선택 범위 반영
        picker.setDateRange(preDate, nextDate);

        // cleanup
        return () => {
            picker.destroy();
            pickerRef.current = null;
        };
        // 화면 레이아웃 전환시에도 재초기화를 원하면 Rwidth 같은 뷰포트 상태도 deps에 포함
    }, [inputRef.current /*, Rwidth */]);

    // 날짜 상태가 바뀌면 picker에도 반영 (인스턴스가 살아있을 때만)
    useEffect(() => {
        pickerRef.current?.setDateRange(preDate, nextDate);
    }, [preDate, nextDate]);

    // 공용 setter
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        setPage(1);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, preDate, nextDate])

    const ListData = async () => {
        if (page == 1) setLoading(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                if (page === 1) {
                    setListData(tmp?.data?.payout ?? []);
                }
                else {
                    setListData((prev) => [...prev, ...tmp?.data?.payout ?? []]);
                }
                setAmount([tmp?.data?.summary?.total_amount ?? 0, tmp?.data?.summary?.total_cancel_amount ?? 0])
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setLoading(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        // { "no": 1, "text": "NO", "width": "50px", "textAlign": "center" },
        { "no": 2, "text": "정산일", "width": "100px", "textAlign": "center" },
        { "no": 3, "text": "거래상태", "width": "100px", "textAlign": "center" },
        // { "no": 4, "text": "거래금액", "width": "100px", "textAlign": "center" },
        // { "no": 5, "text": "수수료율", "width": "100px", "textAlign": "center" },
        // { "no": 6, "text": "수수료", "width": "100px", "textAlign": "center" },
        { "no": 7, "text": "정산금", "width": "120px", "textAlign": "center" },
        // { "no": 8, "text": "결제구분", "width": "100px", "textAlign": "center" },
        // { "no": 9, "text": "구매자명", "width": "100px", "textAlign": "center" },
        // { "no": 10, "text": "상품명", "width": "150px", "textAlign": "center" },
        // { "no": 11, "text": "주문번호", "width": "150px", "textAlign": "center" },
        // { "no": 12, "text": "거래상세", "width": "80px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                tableBodyData.push([
                    // { "no": 1, "text": list.length - i, "width": "50px", "textAlign": "center" },
                    { "no": 2, "text": formatDateTime(data.payout_date), "width": "100px", "textAlign": "center" },
                    { "no": 3, "text": data.status, "width": "100px", "textAlign": "center" },
                    // { "no": 4, "text": Number(data.amt).toLocaleString('ko-KR') + "원", "width": "100px", "textAlign": "right" },
                    // { "no": 5, "text": Number(data.fee_rate).toFixed(2) + "%", "width": "100px", "textAlign": "right" },
                    // { "no": 6, "text": Number(data.fee).toLocaleString('ko-KR') + "원", "width": "100px", "textAlign": "right" },
                    { "no": 7, "text": changeNum(Number(data.requested_amount)), "width": "120px", "textAlign": "right" },
                    // { "no": 8, "text": data.payment_type, "width": "100px", "textAlign": "center" },
                    // { "no": 9, "text": data.quota === "00" ? "." : `${data.quota}개월`, "width": "100px", "textAlign": "center" },
                    // { "no": 10, "text": data.cancelTranDate ? formatDateTime(`${data.cancelTranDate}${data.cancelTranTime}`) : '', "width": "150px", "textAlign": "center" },
                    // { "no": 11, "text": data.order_id, "width": "150px", "textAlign": "center" },
                    // {
                    //     "no": 12,
                    //     "text": (
                    //         <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal(true) }}>
                    //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-archive w-4 h-4" style={{ color: "#0064ff" }}>
                    //                 <path d="M20 9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9m16-5H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-10 9h4"></path>
                    //             </svg>
                    //         </div>
                    //     ),
                    //     "width": "80px",
                    //     "textAlign": "center"
                    // }
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listData]);

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement", {
            withCredentials: true,
            params: {
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.settlement ?? [])
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                console.log(t)

                try {
                    arr.push({
                        "NO": i + 1,
                        "거래일시": t.trx_date,
                        "취소일시": t.cancel_date,
                        "거래상태": t.txtType === "BILL" ? "승인" : "취소",
                        "거래금액": Number(t.amt) + "원",
                        "수수료율": Number(t.fee_rate).toFixed(2) + "%",
                        "수수료": Number(t.fee) + "원",
                        "부가세": Number(t.vat) + "원",
                        "정산금": Number(t.settlement_amt) + "원",
                        "결제서비스": t.payment_type,
                        "구매자명": t.buyer_nm,
                        "상품명": t.prd_nm,
                        "주문번호": t.order_id,
                        "거래번호": t.trx_id,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }


    const isMobile = Rwidth <= 767;

    // 스크롤 컨테이너(모바일 영역) 참조
    const mobileScrollRef = useRef(null);

    // observer 인스턴스 보관
    const ioRef = useRef(null);

    // sentinel을 바꿀 때마다 자동으로 observe/cleanup 되는 콜백 ref
    const setSentinelRef = useCallback((node) => {
        // 이전 관찰 중단
        if (ioRef.current) {
            ioRef.current.disconnect();
            ioRef.current = null;
        }
        if (!node) return;

        // root: 모바일은 내부 스크롤 박스, 데스크톱은 기본(뷰포트 또는 외부 스크롤러)
        const rootEl = isMobile ? mobileScrollRef.current : null;

        ioRef.current = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalPage >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        }, {
            root: rootEl,            // 중요: 모바일에서 내부 스크롤 컨테이너 지정
            rootMargin: "200px 0px", // 여유롭게 미리 로드
            threshold: 0
        });

        ioRef.current.observe(node);
    }, [isMobile, totalPage, page, maxFirstPage]);

    // list 변경·레이아웃 전환 시에도 sentinel 재연결 보장 (콜백 ref가 처리하지만 안전망)
    useEffect(() => {
        return () => { ioRef.current?.disconnect(); };
    }, []);

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            {
                Rwidth > 767
                    ?
                    <div class="content" id="contents">
                        <div class="paylist">
                            <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                                <div class="form_filter w-full">
                                    <SearchDateMonth
                                        type={"날짜"}
                                        inputRef={inputRef}
                                        setDateRange={setDateRange}
                                        preDate={preDate}
                                        nextDate={nextDate}
                                    />
                                </div>
                            </form>
                            <div className="intro-y box p-5 mt-2">
                                {/* <div className="tabulator_sorting_wrap">
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        <CountSelect onChange={handleChangeMaxPage} maxFirstPage={maxFirstPage} />
                    </div> */}
                                <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end' }}>
                                    <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                                        <label>합계 :</label>
                                        <input id="tot_amt" type="text" className="form-control" value={changeNum(amount[0])} readonly="" disabled="" />
                                    </div>
                                </div>
                                <div style={{ maxWidth: "400px", width: "100%" }}>
                                    <List
                                        tableHeaderData={tableHeaderData}
                                        tableBodyData={totalPage ?? 0}
                                        filter_tableBodyData={combineData}
                                        page={page}
                                        setPage={setPage}
                                        maxFirstPage={maxFirstPage}
                                        observerRef={setSentinelRef}
                                        nonePage={false}
                                        scrollState={true}
                                        height={"800px"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ marginTop: "3.5rem", background: "#fff", minHeight: "calc(100dvh - 3.5rem)" }}>
                        <div style={{ padding: "20px 15px", borderBottom: "6px solid #f1f1f1" }}>
                            <SearchDateMobile
                                type={"날짜"}
                                inputRef={inputRef}
                                setDateRange={setDateRange}
                                preDate={preDate}
                                nextDate={nextDate}
                            />
                        </div>
                        <div style={{ padding: "15px 15px 10px", borderBottom: "6px solid #f1f1f1" }}>
                            <div style={{ fontSize: "13px", color: "#a9a9ab", fontWeight: "500", marginBottom: "3px" }}>{`${preDate}~${nextDate}`}</div>
                            <div style={{ padding: "20px 12px", background: "#f5f6f8", borderRadius: "8px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div>정산 합계</div>
                                    <div>
                                        <span>{changeNum(0)}</span>
                                        <span style={{ marginLeft: "2px" }}>원</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "0px 15px", borderBottom: "6px solid #f1f1f1", height: "calc(100dvh - 310px)", overflow: "scroll" }}>
                            {listData.map((item, i) => (
                                <MobileListItem key={i} item={item} />
                            ))}
                            <div ref={setSentinelRef} style={{ height: '1px' }}></div>
                        </div>
                    </div>
            }
        </>
    )
}

function MobileListItem({ item, status }) {
    const raw = item.payout_date; // "2025-08-01 12:45:15"
    const [datePart, timePart] = raw.split(" ");   // ["2025-08-01", "12:45:15"]

    // 날짜: 2025-08-01 → 25.08.01
    const dateStr = datePart.slice(2).replace(/-/g, "."); // "25.08.01"

    return (
        <>
            <div style={{
                display: "flex",
                gap: "15px",
                borderBottom: "1px solid #f1f1f1",
                padding: "12px 0",
                position: "relative"
            }}>
                <div style={{ fontSize: "13px", color: "#82898f", textAlign: "right" }}>
                    <div style={{ height: "15px" }}>{dateStr}</div>
                </div>
                <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "13px", fontWeight: "500", display: "flex", justifyContent: "space-between" }}>
                        {/* <div>빠른결제_가맹 [{item.realtime == "N" ? "익일" : "즉결"}]</div> */}
                        <div style={{ fontSize: '14px' }}>{changeNum(Number(item.requested_amount))}원</div>
                        <div style={{ color: item.status === "완료" ? "green" : "gray" }}>{item.status}</div>
                    </div>
                    {/* <div style={{ fontSize: "13px", fontWeight: "500", marginBottom: "2px", display: "flex", justifyContent: "space-between", height: "18px" }}>
                        <div style={{ color: "#999" }}>매출금액</div>
                        <div style={{ fontSize: '14px' }}>{changeNum(Number(item.requested_amount))}원</div>
                    </div> */}
                    {/* <div style={{ fontSize: "13px", fontWeight: "500", marginBottom: "2px", display: "flex", justifyContent: "space-between" }}>
                        <div style={{ color: "#999" }}>정산금액</div>
                        <div style={{ fontSize: '14px' }}>{changeNum(Number(item.requested_amount))}원</div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "거래일시", "취소일시", "거래상태", "거래금액", "수수료율", "수수료", "부가세", "정산금", "결제서비스", "구매자명", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.수수료율 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.수수료 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.부가세 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.정산금 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Settlement;